import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { lower } from "change-case";
import { Form, reduxForm, getFormValues } from "redux-form";
import { Field } from "redux-form";
import { Button, Breadcrumb, Confirm } from "semantic-ui-react";
import FieldInput, { InputType as type } from "components/SemanticForm";
import { scrollToFirstValidateFailElement } from "core/utilities";
import { validations, validateCase as vCase } from "core/validate";
import { CancelGRContainer } from "./styled";
import { getHrmsMembers } from "ducks/member";
import { cancelGr, checkGRConditionForCancel } from "ducks/support";
import { MainBodyContent } from "components";
import { supportForUserPath, grMainSupportForUserPath } from "routes";
import { getGRDetailByDocNo, clearGRDetail } from "ducks/goodsServiceReceipt";
import { goodsServiceReceiptDetailPath } from "routes";

// import r from 'reactotron-react-js'

const CancelGR = (props) => {
  const { members, memberLoading, reset, history, checkGRCancelData, grData } =
    props;
  const [showConfirm, setShowConfirm] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showError, setShowError] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    props.getHrmsMembers();
    return () => {
      props.clearGRDetail();
    };
  }, []);

  const memberOptions = members.map((m) => ({
    value: lower(m.username),
    text: `${m.firstnameEn} ${m.lastnameEn}`,
  }));

  function submitAction() {
    setShowConfirm(false);
    props.checkGRConditionForCancel(props.valueForm, (data) => {
      afterCheckCondition(data);
    });
  }

  function afterCheckCondition(data) {
    if (data.needConfirm) {
      setWarningMessage(data.message);
      setShowWarning(true);
    } else {
      if (data.canCancel) {
        props.cancelGr(props.valueForm, reset);
      } else {
        setErrorMessage(data.message);
        setShowError(true);
      }
    }
  }

  function LoadGRInfo(data) {
    const docNumber = data?.documentNumber;

    if (!docNumber || docNumber.trim() === "") {
      alert("Please input GR Document Number first.");
      return;
    }

    props.getGRDetailByDocNo(docNumber);
  }

  return (
    <MainBodyContent
      headerTitle="Cancel Goods/Service Receipt (Cancel GR)"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {
                history.push(supportForUserPath);
              },
            },
            {
              key: "gr",
              content: "Goods/Service Receipt (GR)",
              link: true,
              onClick: () => {
                history.push(grMainSupportForUserPath);
              },
            },
            {
              key: "cancelgr",
              content: "Cancel Goods/Service Receipt (Cancel GR)",
              active: true,
            },
          ]}
        />
      }
    >
      <CancelGRContainer>
        <div className="warnningMSG">
          <b>
            Warning! การยกเลิก GR ผ่านระบบ EzProcure ระบบจะยกเลิกใน SAP
            ให้อัตโนมัติ กรณียกเลิกผิดต้องทำ GR ใหม่เท่านั้น{" "}
          </b>
          <div>เงื่อนไขในการยกเลิก GR ต้องตรวจสอบดังนี้</div>
          <ul>
            <li>1. สถานะของเอกสาร GR จะต้อง Completed แล้วเท่านั้น</li>
            <li>2. ตรวจสอบเลขเอกสารให้ถูกต้องก่อนยืนยันการยกเลิก</li>
          </ul>
        </div>
        <Form>
          <div className="rowFields">
            <Field
              name="documentNumber"
              label="GR Document Number"
              className="halfRow"
              type={type.text}
              component={FieldInput}
              require
            />
            <div className="collectiveButtons">
              <Button
                type="button"
                color="blue"
                onClick={() => LoadGRInfo(props.valueForm)}
              >
                Load Data
              </Button>
            </div>
            {Object.keys(grData || {}).length > 0 && (
              <div style={{ alignSelf: "center", paddingLeft: "10px" }}>
                <a
                  href={goodsServiceReceiptDetailPath(grData?.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: "5px", fontSize: "1.3rem" }}
                >
                  Details
                </a>
              </div>
            )}
          </div>
          <div className="rowFields">
            <Field
              name="createdMatDocNo"
              label="Materail Document(SAP)"
              type={type.text}
              component={FieldInput}
              editable={false}
            />
            <Field
              name="createdDocYear"
              label="Year of Materail Document(SAP)"
              type={type.text}
              component={FieldInput}
              editable={false}
            />
          </div>
          <div className="rowFields">
            <Field
              name="requesterCancel"
              label="Requester (User request cancel document)"
              loading={memberLoading}
              options={memberOptions}
              type={type.select}
              component={FieldInput}
              require
            />
            <Field
              name="postingDate"
              label="Posting Date"
              type={type.date}
              component={FieldInput}
              dateFormat="dd MMM yyyy"
              require
            />
          </div>
          <div className="rowFields">
            <Field
              name="reason"
              label="Reason"
              type={type.textArea}
              component={FieldInput}
              require
            />
          </div>
          <div className="btnContainer">
            <Button
              type="button"
              content="Submit"
              color="blue"
              icon="paper plane outline"
              labelPosition="right"
              style={{ marginRight: "5px" }}
              onClick={props.handleSubmit(() => setShowConfirm(true))}
            />
          </div>
          <Confirm
            size="mini"
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={props.handleSubmit(() => submitAction())}
          />
          <Confirm
            open={showWarning}
            header="Are you sure to Cancel?"
            content={warningMessage}
            // confirmButton="Remove"
            onCancel={() => {
              setShowWarning(false);
            }}
            onConfirm={() => {
              props.cancelGr(props.valueForm, reset);
            }}
          />
          <Confirm
            open={showError}
            header="Error!!"
            cancelButton={false}
            content={errorMessage}
            // confirmButton="Remove"
            // onCancel={() => {
            //   setShowWarning(false);
            // }}
            onConfirm={() => {
              setShowError(false);
            }}
          />
        </Form>
      </CancelGRContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => {
  let grDetail = state.gr.grDetail;
  return {
    initialValues: {
      ...grDetail.data,
    },
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    checkGRCancelData: state.support.checkGRCancelData.data,
    grData: grDetail.data,
    valueForm: getFormValues("cancelGrForm")(state) || {},
  };
};

const mapDispatchToProps = {
  getHrmsMembers,
  cancelGr,
  checkGRConditionForCancel,
  getGRDetailByDocNo,
  clearGRDetail
};

const validate = (values) => {
  let errors = {};
  validations(values, "documentNumber", [vCase.require], errors);
  validations(values, "requesterCancel", [vCase.require], errors);
  validations(values, "reason", [vCase.require], errors);

  return errors;
};

const CancelGRForm = reduxForm({
  form: "cancelGrForm",
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
  touchOnChange: false,
  touchOnBlur: false,
})(CancelGR);

export default connect(mapStateToProps, mapDispatchToProps)(CancelGRForm);
